import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Download, Clock, ArrowRight, Leaf, Timer } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  const modules = ['📕 Módulo 1', '📗 Módulo 2', '📘 Módulo 3', '📙 Módulo 4', '📔 Módulo 5', '📒 Módulo 6'];
  const bonuses = ['🎁 Plan de Inicio de 7 Días', '🎁 Calendario de Cosecha', '🎁 Lista de Compras', '🎁 Guía de Riego', '🎁 Identificación de Plagas', '🎁 10 Errores que Arruinan tu Huerta'];
  return <section id="pricing" className="relative w-full py-12 md:py-24 px-4 bg-gradient-to-b from-green-50 to-white overflow-hidden" data-id="element-182">
      {/* Decorative Background Leaves */}
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 50,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -top-20 -right-20 opacity-5 pointer-events-none" data-id="element-183">
        <Leaf className="w-64 h-64 text-green-900" data-id="element-184" />
      </motion.div>
      <motion.div animate={{
      rotate: -360
    }} transition={{
      duration: 60,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -bottom-20 -left-20 opacity-5 pointer-events-none" data-id="element-185">
        <Leaf className="w-72 h-72 text-green-900" data-id="element-186" />
      </motion.div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-187">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-8 md:mb-12" data-id="element-188">
          💸 Elegí tu acceso
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border-4 border-lime-500 rounded-3xl p-6 md:p-12 shadow-[0_20px_50px_rgba(132,204,22,0.15)] relative overflow-hidden" data-id="element-189">
          {/* Subtle leaf pattern overlay */}
          <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.83-1.66 1.66-.83-.83.83-.83zM27.83 30l.83.83-1.66 1.66-.83-.83.83-.83zM54.627 60l.83-.83-1.66-1.66-.83.83.83.83zM27.83 30l.83-.83-1.66-1.66-.83.83.83.83z' fill='%231a4d2e' fill-opacity='1' fill-rule='evenodd'/%3E%3C/svg%3E\")"
        }} data-id="element-190"></div>

          <div className="absolute top-0 right-0 bg-lime-500 text-green-950 font-black px-6 py-2 rounded-bl-2xl shadow-sm text-sm md:text-base" data-id="element-191">
            OFERTA HOY
          </div>

          <div className="text-center mb-8 md:mb-10 mt-4 md:mt-0" data-id="element-192">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-1.5 rounded-full text-xs md:text-sm font-bold mb-6" data-id="element-193">
              <Timer className="w-4 h-4" data-id="element-194" />
              <span data-id="element-195">🔥 Oferta por tiempo limitado</span>
            </div>

            <CountdownTimer durationMinutes={30} variant="large" data-id="element-196" />

            <div className="inline-block bg-green-100 px-4 py-2 rounded-lg mb-4 w-full md:w-auto" data-id="element-197">
              <span className="text-green-800 font-bold text-sm md:text-base" data-id="element-198">
                🌿 ACCESO COMPLETO
              </span>
            </div>
            <h3 className="text-2xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-199">
              HUERTA EXPRESS 30D + BONOS
            </h3>

            <div className="mb-6 bg-gray-50 py-6 rounded-2xl border border-gray-100" data-id="element-200">
              <div className="text-lg md:text-xl text-gray-400 line-through mb-1 font-medium" data-id="element-201">
                $60.000
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-202">
                <span className="text-sm md:text-base font-bold text-green-700" data-id="element-203">
                  HOY:
                </span>
                <span className="text-6xl md:text-7xl font-black text-lime-600 tracking-tight" data-id="element-204">
                  $19.990
                </span>
                <span className="text-sm font-bold text-gray-500" data-id="element-205">ARS</span>
              </div>
            </div>
          </div>

          <div className="mb-8 md:mb-10" data-id="element-206">
            <p className="font-bold text-gray-900 mb-4 text-base md:text-lg" data-id="element-207">
              ✔ Incluye:
            </p>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6" data-id="element-208">
              {modules.map((module, index) => <div key={index} className="flex items-center gap-2" data-id="element-209">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-lime-600 flex-shrink-0" data-id="element-210" />
                  <span className="text-sm md:text-base text-gray-800 font-medium" data-id="element-211">
                    {module}
                  </span>
                </div>)}
            </div>
            <div className="grid md:grid-cols-2 gap-3 bg-lime-50/50 p-4 rounded-xl border border-lime-100" data-id="element-212">
              {bonuses.map((bonus, index) => <div key={index} className="flex items-center gap-2" data-id="element-213">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-lime-600 flex-shrink-0" data-id="element-214" />
                  <span className="text-sm md:text-base text-gray-800 font-medium" data-id="element-215">
                    {bonus}
                  </span>
                </div>)}
            </div>
          </div>

          <motion.a href="https://checkout.infodigitalcore.shop/cart/49495346577647:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0px 0px 0px rgba(132,204,22,0)', '0px 0px 20px rgba(132,204,22,0.5)', '0px 0px 0px rgba(132,204,22,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity
          }
        }} className="relative w-full bg-lime-500 hover:bg-lime-400 text-green-950 font-black text-lg md:text-2xl py-5 md:py-6 rounded-xl shadow-lg transition-colors flex items-center justify-center gap-2 mb-8" data-id="element-216">
            👉 Sí, quiero empezar ahora
            <ArrowRight className="w-6 h-6 md:w-8 md:h-8" data-id="element-217" />
            <Leaf className="absolute -top-3 -right-2 w-6 h-6 text-lime-600 rotate-12 drop-shadow-sm hidden md:block" data-id="element-218" />
          </motion.a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-700 font-medium bg-gray-50 py-4 rounded-xl border border-gray-100" data-id="element-219">
            <div className="flex items-center gap-2 text-green-700 font-bold bg-green-100 px-3 py-1 rounded-full" data-id="element-220">
              <ShieldCheck className="w-4 h-4 md:w-5 md:h-5" data-id="element-221" />
              <span data-id="element-222">GARANTÍA 7 DÍAS</span>
            </div>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-223">
              <div className="flex items-center gap-1.5" data-id="element-224">
                <Check className="w-4 h-4 text-green-600" data-id="element-225" />
                <span data-id="element-226">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-227">
                <Download className="w-4 h-4 text-green-600" data-id="element-228" />
                <span data-id="element-229">Descarga en minutos</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-230">
                <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-231" />
                <span data-id="element-232">Compra segura</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}